import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBDataTable } from "mdbreact";
import moment from "moment";
import MainApp from "../../../layouts/MainApp";
import PrimaryLoader from '../../../includes/Loaders/PrimaryLoader';
import CreateThirdPartyWebHook from "./CreateThirdPartyWebHook";
import { adminActions } from "../../../../redux/actions";

export default function WebHooks() {
  const dispatch = useDispatch();

  let user = JSON.parse(localStorage.getItem("user"));
  let teamId = JSON.parse(localStorage.getItem("teamId"));
  const company_id = user?.data?.groups[teamId]?.company_id;

  const thirdPartyWebhook = useSelector((state) => state.admin.thirdPartyWebhook);
  const loading = useSelector((state) => state.admin.getSettingsLoader);

  useEffect(() => {
    if (company_id) {
      dispatch(adminActions.getThirdPartyWebhooks(company_id));
    }
  }, [dispatch, company_id]);

  function createTableData() {
    let dataToMap = thirdPartyWebhook;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((token, i) => {
        let singleRowArray = {
          created: moment(token.created).format("lll"),
          label: token.label,
          events_allowed: token.events_allowed?.length > 0 && token.events_allowed?.map((event) => <span>{event}, </span>),
          // actions: <span>delete</span>,
        };
        outputArray.push(singleRowArray);
        return true;
      });
      return outputArray;
    }
  }
  const dataSet = createTableData();

  const data = {
    columns: [
      {
        label: "Created at",
        field: "created",
        sort: "asc",
        width: 100,
      },
      {
        label: "Label",
        field: "label",
        sort: "asc",
        width: 200,
      },
      {
        label: "Events Allowed",
        field: "events_allowed",
        sort: "asc",
        width: 500,
      },
    ],
    rows: dataSet,
  };

  return (
    <MainApp>
      {loading ? (
        <PrimaryLoader />
      ) : (
        <div className="main-content-padding">
          <div className="main-content">
            <div className="mb-2  d-flex justify-content-between ">
              <h1 className="mr-2">Third party webhooks</h1>
              <CreateThirdPartyWebHook />
            </div>
            <h5 className="mb-3">
              This allows a third party to create and edit orders for your
              company using the generated token{" "}
            </h5>
            <div className="separator-breadcrumb border-top" />
            <br></br>

            <div className="mb-4">
              <MDBDataTable
                responsive
                searching={false}
                entries={5}
                entriesOptions={[5, 8, 15]}
                striped
                bordered
                hover
                noBottomColumns
                data={data}
              />
            </div>
          </div>
        </div>
      )}
    </MainApp>
  );
}
